import { PermissionList } from '@/libs/defaultList';
export default [
    // *===============================================---*
    /// TEMPLATES ///
    {
        path: '/servicetemplates/list',
        name: 'templates-list',
        component: () => import('@/views/sales/services/template/TemplateList.vue'),
        meta: {
            pageTitle: 'Service Templates List',
            breadcrumb: [
                {
                    text: 'Service Templates List',
                },
            ],
            permission: PermissionList.ServiceManagement_View
        },
    },
    {
        path: '/servicetemplates/add',
        name: 'templates-add',
        component: () => import('@/views/sales/services/template/TemplateAdd.vue'),
        meta: {
            pageTitle: 'Add Service Template',
            breadcrumb: [
                {
                    text: 'Service Templates List',
                    to: '/servicetemplates/list',
                },
                {
                    text: 'Add Service Template',
                    active: true
                },
            ],
            permission: PermissionList.ServiceManagement_View
        },
    },
    {
        path: '/servicetemplates/edit/:id',
        name: 'templates-edit',
        component: () => import('@/views/sales/services/template/TemplateEdit.vue'),
        meta: {
            pageTitle: 'Edit Service Template',
            breadcrumb: [
                {
                    text: 'Service Template List',
                    to: '/servicetemplates/list',
                },
                {
                    text: 'Edit Service Template',
                    active: true
                },
            ],
            permission: PermissionList.ServiceManagement_View
        },
    },

    /// SERVICES ///
    {
        path: '/servicerequest/list',
        name: 'request-list',
        component: () => import('@/views/sales/services/requests/RequestList.vue'),
        meta: {
            pageTitle: 'Service Requests List',
            breadcrumb: [
                {
                    text: 'Service Request Lists',
                    active: true,
                },
            ],
            permission: PermissionList.ServiceManagement_View
        },

    },
    {
        path: '/servicerequest/add',
        name: 'servicerequest-add',
        component: () => import('@/views/sales/services/requests/add/main.vue'),
        meta: {
            pageTitle: 'Add Service Request',
            breadcrumb: [
                {
                    text: 'Service Requests List',
                    to: '/servicerequest/list',
                },
                {
                    text: 'Add Service Request',
                    active: true,
                },
            ],
            permission: PermissionList.ServiceManagement_Create
        },

    },
    {
        path: '/servicerequest/edit/:id',
        name: 'servicerequest-edit',
        component: () => import('@/views/sales/services/requests/edit/main.vue'),
        meta: {
            pageTitle: 'Edit Service Request',
            breadcrumb: [
                {
                    text: 'Service Requests List',
                    to: '/servicerequest/list',
                },
                {
                    text: 'Edit Service Request',
                    active: true,
                },
            ],
            permission: PermissionList.ServiceManagement_Update
        },
    },
    {
        path: '/servicerequest/view/:id',
        name: 'servicerequest-view',
        component: () => import('@/views/sales/services/requests/view/main.vue'),
        meta: {
            pageTitle: 'View Service Request',
            breadcrumb: [
                {
                    text: 'Service Requests List',
                    to: '/servicerequest/list',
                },
                {
                    text: 'View Service Request',
                    active: true,
                },
            ],
            permission: PermissionList.ServiceManagement_View
        },

    },

    {
        path: '/serviceorder/list',
        name: 'serviceorder-list',
        component: () => import('@/views/sales/services/order/ServiceOrderList.vue'),
        meta: {
            pageTitle: 'Service Order List',
            breadcrumb: [
                {
                    text: 'Service Order List',
                },
            ],
            permission: PermissionList.ServiceManagement_View
        },
    },
    {
        path: '/serviceorder/add',
        name: 'serviceorder-add',
        component: () => import('@/views/sales/services/order/AddServiceOrder.vue'),
        meta: {
            pageTitle: 'Add Service Order',
            breadcrumb: [
                {
                    text: 'Service Order List',
                    to: '/serviceorder/list'
                },
                {
                    text: 'Add Service Order',
                    active: true
                },
            ],
            permission: PermissionList.ServiceManagement_Create
        },
    },
    {
        path: '/serviceorder/edit/:id',
        name: 'serviceorder-edit',
        component: () => import('@/views/sales/services/order/EditServiceOrder.vue'),
        meta: {
            pageTitle: 'Edit Service Order',
            breadcrumb: [
                {
                    text: 'Service Order List',
                    to: '/serviceorder/list',
                },
                {
                    text: 'Edit Service Order',
                    active: true
                },
            ],
            permission: PermissionList.ServiceManagement_Update,
            viewOnly: false
        },
    },
    {
        path: '/serviceorder/view/:id',
        name: 'serviceorder-view',
        component: () => import('@/views/sales/services/order/EditServiceOrder.vue'),
        meta: {
            pageTitle: 'View Service Order',
            breadcrumb: [
                {
                    text: 'Service Order List',
                    to: '/serviceorder/list',
                },
                {
                    text: 'View Service Order',
                    active: true
                },
            ],
            permission: PermissionList.ServiceManagement_View,
            viewOnly: true
        },
    },
    {
        path: '/ordertemplate/list',
        name: 'ordertemplate-list',
        component: () => import('@/views/sales/services/ordertemplate/TemplateList.vue'),
        meta: {
            pageTitle: 'Order Template List',
            breadcrumb: [
                {
                    text: 'Order Template List',
                },
            ],
            permission: PermissionList.ServiceManagement_View
        },
    },
    {
        path: '/servicetimesheet/list',
        name: 'servicetimesheet-list',
        component: () => import('@/views/sales/services/timesheet/Timesheet.vue'),
        meta: {
            pageTitle: 'Timesheet',
            breadcrumb: [
                {
                    text: 'Timesheet List',
                },
            ],
            permission: PermissionList.ServiceManagement_View
        },
    },
    {
        path: '/servicetimesheet/add/:id?',
        name: 'servicetimesheet-add',
        component: () => import('@/views/sales/services/timesheet/Add.vue'),
        meta: {
            pageTitle: 'Add Timesheet',
            breadcrumb: [
                {
                    text: 'Timesheet List',
                    to: '/servicetimesheet/list',
                },
                {
                    text: 'Add Timesheet',
                    active: true
                },
            ],
            type: "add",
            permission: PermissionList.ServiceManagement_View
        },
    },
    {
        path: '/servicetimesheet/edit/:id',
        name: 'servicetimesheet-edit',
        component: () => import('@/views/sales/services/timesheet/Add.vue'),
        meta: {
            pageTitle: 'Edit Timesheet',
            breadcrumb: [
                {
                    text: 'Timesheet List',
                    to: '/servicetimesheet/list',
                },
                {
                    text: 'Edit Timesheet',
                    active: true
                },
            ],
            type: "edit",
            permission: PermissionList.ServiceManagement_View
        },
    },
    {
        path: '/servicetimesheet/view/:id',
        name: 'servicetimesheet-view',
        component: () => import('@/views/sales/services/timesheet/Add.vue'),
        meta: {
            pageTitle: 'View Timesheet',
            breadcrumb: [
                {
                    text: 'Timesheet List',
                    to: '/servicetimesheet/list',
                },
                {
                    text: 'View Timesheet',
                    active: true
                },
            ],
            type: "view",
            permission: PermissionList.ServiceManagement_View
        },
    },
    
]